import { Box, Button, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { CloseIcon } from '@chakra-ui/icons';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import Sellout from './sellout';
import GeneralInfo from './generalInfo';

export default function DetailModal() {
    const modalWidth = '600px';
    const { isOpenDetailModal, onChangeMainState } = useMainState();

    const onCloseHandler = () => {
        onChangeMainState({
            isOpenDetailModal: false,
        });
    };

    return (
        <ModalTemplate
            isOpen={isOpenDetailModal}
            width={modalWidth}
            onClose={onCloseHandler}
            isClosebyOverlayClick={false}
        >
            <Box p={'24px'} pb={0}>
                <Flex mb={'12px'} justifyContent={'space-between'} alignItems={'center'}>
                    <Text fontWeight={'600'} fontSize={'24px'}>
                        Detail Sellout
                    </Text>

                    <Button onClick={onCloseHandler} variant={'unstyled'}>
                        <CloseIcon fontSize={'12px'} />
                    </Button>
                </Flex>

                <Tabs>
                    <TabList>
                        <Tab>Sellout</Tab>
                        <Tab>Informasi Umum</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <Sellout />
                        </TabPanel>
                        <TabPanel>
                            <GeneralInfo />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </ModalTemplate>
    );
}
